interface TopRisk {
  id: number | string
  title: string
  project: string
  impact: 'Critical' | 'High' | 'Medium'
  probability: number
  financialImpact: string
}

interface TopRisksListProps {
  risks: TopRisk[]
  onViewAll?: () => void
  onRiskClick?: (risk: TopRisk) => void
}

export function TopRisksList({ risks, onViewAll, onRiskClick }: TopRisksListProps) {
  return (
    <div className="bg-white p-6 rounded-xl border-2 border-[#bcccdc] shadow-lg">
      <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-[#f0f4f8]">
        <h2 className="text-lg text-[#102a43]">Top 5 Portfolio Risks</h2>
        {onViewAll && (
          <button
            onClick={onViewAll}
            className="text-[#486581] hover:text-[#102a43] text-sm font-medium"
          >
            View All Risks →
          </button>
        )}
      </div>
      {risks.length === 0 ? (
        <div className="text-center py-8 text-[#486581]">
          <p className="text-sm">No risks identified at this time.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {risks.map((risk) => (
          <div
            key={risk.id}
            onClick={() => onRiskClick?.(risk)}
            className={`flex items-center gap-4 p-4 bg-[#f0f4f8] border-2 border-[#bcccdc] rounded-lg hover:bg-white hover:border-[#829ab1] hover:shadow-md transition-all ${
              onRiskClick ? 'cursor-pointer' : ''
            }`}
          >
            <div
              className={`p-2 rounded-lg ${
                risk.impact === 'Critical' ? 'bg-red-100' : 'bg-yellow-100'
              }`}
            >
              <svg
                className={`w-5 h-5 flex-shrink-0 ${
                  risk.impact === 'Critical' ? 'text-red-600' : 'text-yellow-600'
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-1">
                <h3 className="font-medium text-[#102a43]">{risk.title}</h3>
                <span
                  className={`px-2 py-0.5 rounded text-xs font-medium border ${
                    risk.impact === 'Critical'
                      ? 'bg-red-100 text-red-700 border-red-300'
                      : risk.impact === 'High'
                        ? 'bg-yellow-100 text-yellow-700 border-yellow-300'
                        : 'bg-blue-100 text-blue-700 border-blue-300'
                  }`}
                >
                  {risk.impact}
                </span>
              </div>
              <p className="text-sm text-[#486581]">{risk.project}</p>
            </div>
            <div className="text-right">
              <div className="text-sm mb-1 text-[#829ab1]">
                Probability: <span className="text-[#486581] font-medium">{risk.probability}%</span>
              </div>
              <div className="text-sm text-red-600 font-medium">{risk.financialImpact}</div>
            </div>
          </div>
        ))}
        </div>
      )}
    </div>
  )
}

